import React from 'react';

import { Reservations } from '@components';

import './style.scss';

interface IProps {}

export class ReservationsPage extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return <Reservations />;
  }
}
